import { CarouselItem } from '../carousel/CarouselItem';

export function renderItem(item, itemIndex, carouselImageRatio) {
  return (
    <CarouselItem
      key={item?.id ?? itemIndex}
      id={itemIndex}
      data={item}
      carouselImageRatio={carouselImageRatio}
    />
  );
}
